import { HorizontalAlignment, ModelRow, Navigation } from "@mcleod/core";
import { ClickEvent, Label, Layout, SlideoutDecorator, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutEdiInboundLogQuickInfoTable } from "./autogen/AutogenLayoutEdiInboundLogQuickInfoTable";

import { TransmissionControlExpanded } from "./TransmissionControlExpanded";

export class EdiInboundLogQuickInfoTable extends AutogenLayoutEdiInboundLogQuickInfoTable {
    private _transmissionStatusURL = "lme/datafusion/TransmissionControlList?ids="

    onLoad(): void | Promise<void> {
        for (const column of this.tableInboundLogHistory.columns) {
            column.headingCell.align = HorizontalAlignment.LEFT;
        }
    }

    onLoadDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelLogId = tableRow.findComponentById("labelLogId") as Label;
        if (labelLogId) {
            labelLogId.addUnderlineWhenMouseOver();
        }
    }

    /** This is an event handler for the onClick event of tableInboundLogHistory rows. */
    OnClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data as ModelRow;
        const ediLogId = modelRow.get("id");
        const layout = Layout.getLayout("lme/datafusion/TransmissionControlExpanded", {
            width: window.innerWidth * 0.75,
            backgroundColor: "defaultBackground",
            fillHeight: true,
            paddingBottom: 50
        }) as TransmissionControlExpanded;
        layout.logId = ediLogId;
        new SlideoutDecorator({
            layout,
            title: "Transmission Control",
            fillVerticalSpace: true,
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                layout.sourceTransmissionControlList.search({ ids: ediLogId }).then(() => {
                    layout.setupLayoutByEdiLogId();
                });
            }
        });
    }

    /** This is an event handler for the onClick event of imagePopOut. */
    imagePopOutOnClick(event: ClickEvent) {
        const ediLogIds: string[] = this.tableInboundLogHistory.rows
            .map((row: TableRow) => {
                const modelRow = row.data as ModelRow;
                return modelRow.get("id");
            })
            .filter((id: string | undefined) => id !== undefined);

        const url = this._transmissionStatusURL;
        Navigation.navigateTo(url + encodeURIComponent(ediLogIds.join(",")), { newTab: true });
    }
}
